var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "yellow-checkmark",
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "yellow-checkmark-1",
    points: "19 3.18 7.093 14.646 0 7.783 3.256 4.603 7.093 8.285 15.744 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "yellow-checkmark-2",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "yellow-checkmark-3",
    fill: "#FFF308"
  }, /*#__PURE__*/React.createElement("use", {
    id: "yellow-checkmark-4",
    xlinkHref: "#yellow-checkmark-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "yellow-checkmark-5",
    fill: "#FFF308",
    fillRule: "nonzero",
    xlinkHref: "#yellow-checkmark-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowCheckmark);
export default __webpack_public_path__ + "static/media/yellow-checkmark.444f393afeee64419c38c380d9abec10.svg";
export { ForwardRef as ReactComponent };